import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  Select, // Ensure Select is imported
  LoadingOverlay,
  Text,
  Paper,
  Group,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { GET_ALL_SUPPLIERS, GET_SUPPLIERS_PAYOUTS, PAYMENT_TYPES } from "apollo/queries"; // Import PAYMENT_TYPES
import { customLoader } from "components/utilities/loader";
import { CREATE_SUPPLIER_PAYOUT } from "apollo/mutuations";
import { formatNumber } from "utiles/url";

const SupplierAddPayout = ({
  setOpened,
  size,
  activePage,
  supplierPayout,
  refetch,
}) => {
  const [selectedSupplierData, setSelectedSupplierData] = useState(null);

  // 1. Fetch Payment Types from API
  const { data: paymentTypesData, loading: loadingPaymentTypes } = useQuery(PAYMENT_TYPES);

  // 2. Format the data for Mantine Select component
  const paymentOptions = paymentTypesData?.paymentTypesNonPaginated?.map((item) => ({
    value: item.name, // or item.id depending on what your backend expects
    label: item.name,
  })) || [];

  const form = useForm({
    initialValues: {
      amount: supplierPayout.total_paid_amount > 0 
        ? supplierPayout.remaining_amount
        : supplierPayout.total_net_amount || 0,
      reference: "",
      payment_method: "",
    },

    validate: {
      amount: (value) => {
        if (!value) return "Amount is required";
        if (isNaN(value) || parseFloat(value) <= 0)
          return "Amount must be a positive number";
        if (selectedSupplierData && parseFloat(value) > selectedSupplierData.balance) {
          return "Amount exceeds available balance";
        }
        return null;
      },
      reference: (value) => (!value ? "Reference is required" : null),
      payment_method: (value) => (!value ? "Payment method is required" : null),
    },
  });

  const [addPayout, { loading: payoutLoading }] = useMutation(CREATE_SUPPLIER_PAYOUT);

  const { height } = useViewportSize();

  const submit = () => {
    if (form.validate().hasErrors) return;
    const variables = {
      supplier_id: supplierPayout?.id,
      amount: parseFloat(form.values.amount),
      reference: form.values.reference,
      payment_method: form.values.payment_method,
    };
    addPayout({
      variables,
      onCompleted() {
        showNotification({
          color: "green",
          title: "Success",
          message: "Payout Created",
        });
        setOpened(false);
        refetch();
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message: error?.graphQLErrors?.[0]?.message || "Failed to create payout",
        });
      },
    });
  };

  return (
    <>
      <LoadingOverlay visible={payoutLoading || loadingPaymentTypes} loader={customLoader} />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  required
                  type="number"
                  label="Amount"
                  placeholder="Enter amount"
                  {...form.getInputProps("amount")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Reference"
                  placeholder="Enter reference"
                  {...form.getInputProps("reference")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                {/* 3. Replaced TextInput with Select */}
                <Select
                  required
                  label="Payment Method"
                  placeholder="Select payment method"
                  data={paymentOptions}
                  searchable
                  nothingFound="No payment methods found"
                  {...form.getInputProps("payment_method")}
                />
              </Grid.Col>
            </Grid>

            <Button
              style={{
                width: "20%",
                backgroundColor: "#FF6A00",
                color: "#FFFFFF",
              }}
              type="submit"
            >
              Submit
            </Button>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default SupplierAddPayout;